import CustomModal from "../../../../components/CustomModal";
import Image from "../../../../components/images/Image";
import ToolTip from "../../../../components/ToolTip/ToolTip";
import config from "../../../../config/config";
import AudioMessage from "./AudioMessage";

export default function ViewTicketModal({
    showModal,
    setShowModal,
    ticketDetails,
    userCode
}) {

    function formatDate(isoString) {
        const date = new Date(isoString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;

        return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
    }
    const getStyles = () => {
        switch (ticketDetails?.status) {
            case "Open":
                return "bg-positive_light text-positive";
            case "In Progress":
                return "bg-warning_light text-warning";
            case "Closed":
                return "bg-disable_fill text-secondary_text";
            default:
                return "bg-gray-300";
        }
    };
    return (
        <CustomModal 
            isOpen={showModal} 
            secondaryButton={false} 
            maxWidth="max-w-[60%]" 
            onClose={() => setShowModal(false)} 
            showCloseButton={false}
            primaryButtonText="Close"
            handelSubmit={() => setShowModal(false)}
            noButtons={true}
        >
            <div data-testid="custom-modal">
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-4">
                        <h1 className="text-xl font-semibold text-gray-900">{`Ticket ID - ${ticketDetails?.ticket_id}` || '-'}</h1>
                        <span className="text-sm text-gray-500">{formatDate(ticketDetails?.created_at) || '-'}</span>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className={`rounded-[8px] overflow-hidden h-fit ${getStyles()}`}>
                            <div className="px-5 py-1 text-[14px] font-normal">{ticketDetails?.status}</div>
                        </div>
                        <Image src="close" onClick={() => setShowModal(false)} className="cursor-pointer" />
                    </div>
                </div>

                {/* Customer Info */}
                <div className="mb-6">
                    <h2 className="text-lg font-medium text-gray-900 mb-1">{`${ticketDetails?.full_name}(${ticketDetails?.user_code || 'Guest'})`}</h2>
                </div>

                {/* Reason */}
                <div className="mb-6">
                    <h3 className="text-sm font-medium text-gray-700 mb-2">Reason</h3>
                    <p className="text-body1">{ticketDetails?.reason || '-'}</p>
                </div>

                {/* Description */}
                <div className="mb-8">
                    <h3 className="text-sm font-medium text-gray-700 mb-2">Description</h3>
                    <p className="text-body1 leading-relaxed text-wrap break-all text-justify">
                        {ticketDetails?.description || '-'}
                    </p>
                </div>

                {/* File Sections */}
                <div className="flex gap-6">
                    {/* Uploaded Document */}
                    {ticketDetails?.document &&
                        <div className="w-[340px]">
                            <h3 className="text-sm font-medium text-gray-700 mb-3">Uploaded Document</h3>
                            <div className="w-full h-fit flex  justify-between gap-1 overflow-hidden text-ellipsis py-[15px] px-[18px] bg-background_blue mt-2 rounded-[8px] text-body1" data-testid="employee-id-front-container">

                                <p className="more-lines" data-testid="employee-id-front-filename">{ticketDetails?.document.split("/").pop()}</p>
                                <ToolTip ToolTipItem={ticketDetails?.document.split("/").pop() || ''} top="top-0" />
                                <Image
                                    src="file-eye"
                                    className="cursor-pointer"
                                    objectFit="contain"
                                    testId="employee-id-card-front-page-image"
                                    onClick={() => {
                                        const documentPath = ticketDetails?.document || '';
                                        if (!documentPath) return;
                                        
                                        if (!config?.cdnURL) {
                                            console.error('CDN URL is not configured. Please set VITE_S3_URL environment variable.');
                                            return;
                                        }
                                        
                                        // Remove 'public/' if it already exists to avoid duplication
                                        const cleanPath = documentPath.startsWith('public/') 
                                            ? documentPath.replace(/^public\//, '') 
                                            : documentPath;
                                        
                                        // Ensure cdnURL ends with / and construct URL
                                        const baseUrl = config.cdnURL.endsWith('/') ? config.cdnURL : `${config.cdnURL}/`;
                                        const fileUrl = `${baseUrl}public/${cleanPath}`;
                                        
                                        window.open(fileUrl, "_blank");
                                    }}
                                />
                            </div>
                        </div>
                    }
                    {/* Voice Note */}
                    {ticketDetails?.recording && <div>
                        <h3 className="text-sm font-medium text-gray-700 mb-3">Voice Note Uploaded</h3>
                        <AudioMessage audioKey={ticketDetails?.recording} />
                    </div>}
                </div>


            </div>

        </CustomModal >
    )
}